import styled from 'styled-components';

interface IPropsInputLabel {
  gridColumnStart?: number | 'auto';
  gridColumnEnd?: number | 'auto';
}

export const VehicleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  height: fit-content;
  min-height: 100vh;
  padding: 24px;
`;

export const FormWrapper = styled.form`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  div {
    font-weight: 400;
  }

  input {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const InputLabel = styled.div<IPropsInputLabel>`
  grid-column-start: ${(props) => props.gridColumnStart};
  grid-column-end: ${(props) => props.gridColumnEnd};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;
